<h3>[{{breakpoint}}]</h3>

<div class="dashboard">
    <div class="card p-2"
        *ngFor="let placement of placements"
        [style.grid-column]="placement.xStart + ' / ' + (placement.xEnd + 1)"
        [style.grid-row]="placement.yStart + ' / ' + (placement.yEnd + 1)">
        <div class="card-title">{{placement.dashboardComponent.name}}</div>
        <div class="card-body">
            <ng-container [ngSwitch]="placement.dashboardComponent.componentType">
                <ng-container *ngSwitchCase="'PlainText'">
                    {{placement.dashboardComponent.query}}
                </ng-container>
				<app-dashboard-chart-bar     *ngSwitchCase="'BarChart'"></app-dashboard-chart-bar>
				<app-dashboard-chart-line    *ngSwitchCase="'LineChart'"></app-dashboard-chart-line>
				<app-dashboard-chart-pie     *ngSwitchCase="'PieChart'"></app-dashboard-chart-pie>
				<app-dashboard-chart-gauge   *ngSwitchCase="'GaugeChart'"></app-dashboard-chart-gauge>
				<app-dashboard-chart-scatter *ngSwitchCase="'ScatterChart'"></app-dashboard-chart-scatter>
				<app-dashboard-table 		 *ngSwitchCase="'Table'"></app-dashboard-table>
                <ng-container *ngSwitchDefault>
                    <span>Unsupported component type: {{placement.dashboardComponent.componentType}}</span>
                </ng-container>
            </ng-container>
        </div>
    </div>
</div>
